import { Action } from '@ngrx/store'
import { Campaign } from './../components/manager-home/model/CampaignModel';


export enum ManagerHomeActionTypes {
  SELECT_CAMPAIGN = "[SELECT_CAMPAIGN] select campaign"
}

export class SelectCampaign implements Action {
  readonly type = ManagerHomeActionTypes.SELECT_CAMPAIGN;
  constructor(public payload: { campaign: Campaign }) {

  }
}

export type ManagerHomeActions = SelectCampaign;
